<!-- 课程管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>uid</span>
          <el-input
            v-model="queryInfo.mobile"
            clearable
            size="small"
            placeholder="请输入UID/手机号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>考生姓名</span>
          <el-input
            v-model="queryInfo.name"
            clearable
            size="small"
            placeholder="请输入考生姓名"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>收件人姓名</span>
          <el-input
            v-model="queryInfo.address_name"
            clearable
            size="small"
            placeholder="请输入收件人姓名"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>定制时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            @change="selectData"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>订单状态</span>
           <el-select 
              v-model="queryInfo.status"
              size="small"
              class="w200Select" 
            > 
              <el-option label="全部" :value="0"></el-option>
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
        </div> 
         
        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>
   
        <MyButton
          value="开通定制资料"
          size="medium"
          type="3"
          @click="addFn()"
        ></MyButton>

        <span class="kyye" @click="kyyeFn()">可用余额：{{ surplus_custom_data_fee }}</span>
        
        
        <el-popover placement="bottom" width="900" trigger="hover">
          <div style="white-space: pre-line">
            <iframe
              :src="BKTdzzmentform"
              :width="firstWidth"
              :height="firstHeight"
              frameborder="0"
              allowfullscreen
              />
          </div>
          <i class="el-icon--right questionIcon" slot="reference"></i>
        </el-popover>
      </div> 
      <div class="table">
        <el-table 
          :data="tableList"
          style="width: 100%"
          v-loading="loading"
          border  
        >   
          <el-table-column prop="id" label="ID" align="center" width="80" />
          <el-table-column label="用户手机号/UID" align="center">
            <template slot-scope="scope">
              <div style="display: block;font-weight: bold;">{{ scope.row.mobile }}</div>
              <div v-if="scope.row.uid">UID：{{ scope.row.uid }}</div>
            </template>
          </el-table-column> 
          <el-table-column align="left">
            <template slot="header">
              <div style="text-align: center;">定制信息</div>
            </template>
            <template slot-scope="scope">
              <div v-if="scope.row.custom_mode_name">省份类别： {{ scope.row.custom_mode_name }}</div>
              <div v-if="scope.row.name">考生姓名： {{ scope.row.name }}</div>
              <div v-if="scope.row.dzs_cate_pid == '7080' || scope.row.app_type == 'xdzdz' || scope.row.attr_id">
                考生类别：
                <span v-if="scope.row.dzs_cate_pid == '7080' || scope.row.app_type == 'xdzdz'">{{ scope.row.attr_id == 1 ? '普高生' : '三校生' }}</span>
                <span v-else>{{ attrMap.get(scope.row.attr_id.toString()) }}</span>
              </div>
              <div v-if="scope.row.college_title">报考院校： {{ scope.row.college_title }}</div>
              <div v-if="scope.row.major_title">报考专业： {{ scope.row.major_title }}</div>
            </template>
          </el-table-column>
          <el-table-column label="定制资料类别" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.goods && scope.row.goods.length > 0">
                <el-tag style="margin: 2px;">
                  {{ customizedResMatchGoodsOptions.find(option => option.value === scope.row.type).flag }}
                </el-tag>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column label="收件信息" align="center">
            <template slot-scope="scope">
              <div style="text-align: left;">{{ scope.row.address_name }}</div>
              <div style="text-align: left;">{{ scope.row.address_phone }}</div>
              <div style="text-align: left;">{{ scope.row.address }}</div>
              <!-- <el-button type="text" @click="editAddressFn(scope.row)">修改></el-button> -->
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" align="center" />
          <el-table-column label="订单状态" align="center">
            <template slot-scope="scope">
              <div :style="{color: statusColorMap.get(scope.row.status.toString())}">
                {{ statusMap.get(scope.row.status.toString()) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="快递发货" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.express_name">{{ scope.row.express_name }}</div>
              <div v-if="scope.row.express_code">{{ scope.row.express_code }}</div>
            </template>
          </el-table-column> 
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div> 
  </div>
</template>

<script>  
import commonApi from "@/api/common";
import goodsApi from "@/api/goods.js";
import { deepClone } from "@/utils"; 
import MyButton from "@/components/MyButton.vue";
export default {
  name: "CustomOrderList", 
  components: { 
    MyButton,
  },
  data() {
    return { 
      queryInfo: {
        status: 0,
        limit: 10,
        page: 1,
        total: 0,
      },  
      tableList: [],
      timeFrame: [], 
      attrOptions: [],
      statusOptions: [ // 0全部 1待生成 2待对接3 已发货 4取消
        // { value: '0', label: '全部', color: '#333333' },
        { value: '1', label: '待生成PDF', color: '#ff0b0b' },
        { value: '2', label: '待对接打印', color: '#6140b5' },
        { value: '5', label: '已打印', color: '#409EFF' },
        { value: '3', label: '已发货', color: '#095d33' },
        { value: '4', label: '已取消', color: '#373737' }
      ],
      customizedResMatchGoodsOptions: [], 
      surplus_custom_data_fee: 0,
      goodInfo: {}, 
      BKTdzzmentform: "",
      firstWidth:'100%',
      firstHeight:'800px',
      loading: false
    };
  },
  computed: { 
    attrMap() {
      return new Map(this.attrOptions.map(item => [item.key, item.value]))
    },
    statusMap() {
      return new Map(this.statusOptions.map(item => [item.value, item.label]))
    },
    statusColorMap() {
      return new Map(
        this.statusOptions.map(item => [item.value, item.color])
      )
    },
  },
  watch: {
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },  
  },
  created() { 
    console.log('NODE_ENV', process.env.NODE_ENV)
    if (process.env.NODE_ENV === 'development') {
      this.BKTdzzmentform = 'http://testLavaMobile.qbting.com/testtask/#/web?key=BKTdzzmentform&apptype=beikaotong' 
    } else {
      this.BKTdzzmentform = 'http://qmb.meite.com/task/#/web?key=BKTdzzmentform&apptype=beikaotong' 
    } 
    this.getDic() 
    this.queryTable(); 
  },
  methods: {  
    kyyeFn(){
      // 可用余额
      this.$router.push({
        path: "/customOrderFlowing", 
      });
    },
    addFn(){
      // 开通定制资料
      this.$router.push({
        path: "/customOrderAdd",
        query: { 
          good_id: this.goodInfo.good_id,
          tob_good_id: this.goodInfo.tob_good_id,
          tob_order_from: this.tob_order_from
        }, 
      });
    },   
    getDic() {
      commonApi.getDictionaries({ names: "senioriupEnrollType,customizedResMatchGoods" }).then((res) => {
        if (res.data && res.data.senioriupEnrollType) { 
          this.attrOptions = res.data.senioriupEnrollType
        }  
        if (res.data && res.data.senioriupEnrollType) { 
          this.customizedResMatchGoodsOptions = res.data.customizedResMatchGoods
        }   
      }) 
    }, 
    selectData(e) {
      if (e) { 
        this.queryInfo.start_at = e[0];
        this.queryInfo.end_at = e[1]; 
      } else {
        this.queryInfo.start_at = "";
        this.queryInfo.end_at = ""; 
      }
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      } 
      this.loading = true
      const res = await commonApi.getCustomOrderList(this.queryInfo); 
      this.loading = false
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;  
        this.surplus_custom_data_fee = res.data.surplus_custom_data_fee; 
        this.goodInfo = res.data.good
        this.tob_order_from = res.data.tob_order_from
      } else {
        this.$message.error(res.message);
      }
    },  
    // 分页
    handleSizeChange(e) { 
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    // 重置
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        status: 0,
        limit: 10,
        page: 1,
        total: 0,
      }; 
      this.queryTable();
    }, 
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin-right: 30px;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0 20px 0;
    .el-button {
      margin-bottom: 5px;
    }
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }
  // .operationItem {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: #00c793;
  // }
  // .operationItem:hover {
  //   color: red;
  // }
  // .operationItemNew {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: #846ffd;
  //   border: 1px solid #846ffd;
  //   border-radius: 4px;
  //   font-size: 13px;
  //   padding: 0 10px;
  // }
  // .operationItemNew:hover {
  //   color: red;
  //   border: 1px solid red;
  // }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;

    .el-pagination{
     display: flex;
     flex-wrap: wrap;
    }
  }

  /deep/ .formDialog {
    .courseDetail {
      img {
        width: 200px;
      }
      p {
        margin-bottom: 10px;
      }
      .couseUl {
        text-decoration: none;
        height: 400px;
        overflow: auto;
        margin-top: 20px;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .sellPriceType {
          background-color: rgb(89, 89, 246);
          color: #fff;
          margin: 0 25px;
          border-radius: 10px;
        }
      }
    }
    .userInfoFormStyle {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      .t1 {
        padding: 0 12px 0 0;
        width: 100px;
        box-sizing: border-box;
        text-align: right;
      }
      .t2 {
      }
      .t3 {
      }
    }
    .userInfoFormStyle-price {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      justify-content: start;
      padding: 0 20px;
      .userInfoFormStyle-price-item {
        width: 50%;
      }
    }
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }
}

.teach-extend-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .teach-extend-box-tc {
    color: #d9001b;
  }
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
/deep/.tob_good_status_box .el-button--success{
    background: linear-gradient(234deg, #9583ff 0%, #7057ff 100%);
    border-color: #9583ff;
    opacity: 1;
    padding: 5px 10px;
    font-size: 12px;
}
/deep/.tob_good_status_box .el-button--success:hover{
    color: #846ffd; 
    border: 1px solid #846ffd;
    background: #fff;
}
/deep/.tob_good_status_box .el-button{
  color: #fff;
}
/deep/.tob_good_status_box .el-button--info{
  color: #FFF;
  background-color: #909399;
  border-color: #909399;
  opacity: 1;
  padding: 5px 10px;
  font-size: 12px;
}

/deep/.kyye{
    border: 1px solid #00C793;
    border-radius: 3px;
    color: #00C793;
    padding: 0 20px;
    font-size: 14px;
    margin: 0;
    line-height: 40px;
    margin-left: 20px;
    cursor: pointer;
}
 
.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
.questionIcon:hover {
  background-image: url("../../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}


/* 针对小屏幕设备（例如手机） */
@media (max-width: 600px) {
  .basicStyle{
    padding: 0;
  }
  
 /deep/.el-pagination{
     display: flex;
     flex-wrap: wrap;
  } 
}  
</style>
